/**
 * Dependencies
 */
import React, { useState } from 'react';
import DocumentTitle from 'react-document-title';

import { Box } from '@nerdwallet/currency';
import { useFeatureFlag } from '@nerdwallet/features';

// Local Components
import { FEATURE_FLAGS } from '@constants/feature-flags';
import VerticalComparison from '../components/front-page/vertical-comparison/vertical-comparison';
import CCBest from '../components/front-page/cc-best/cc-best';
import Testimonials from '../components/front-page/testimonials/testimonials';
import RegistrationModule from '../components/front-page/registration-module/registration-module';
import RewardsModule from '../components/front-page/rewards-module';
import NewsArticles from '../components/front-page/news-articles/news-articles-container/news-articles-container';
import AnnouncementBanner from '../components/front-page/announcement-banner';

// Other Local Dependencies
import {
  verticalComparisonContent,
  ccBestContent,
  testimonialsContent,
  registrationModuleContent,
} from '../lib/front-page-content';

const FrontPage = () => {
  const documentTitle = 'NerdWallet: Make all the right money moves';
  const [showAnnouncementBanner, setShowAnnouncementBanner] = useState(true);
  const { data: wildfireFeatureFlag } = useFeatureFlag({
    featureFlagName: FEATURE_FLAGS.WILDFIRE_POC,
  });

  return (
    <React.Fragment>
      <DocumentTitle title={documentTitle} />
      <Box marginTop={4}>
        <If condition={showAnnouncementBanner && !!wildfireFeatureFlag?.value}>
          <AnnouncementBanner
            handleOnClose={() => setShowAnnouncementBanner(false)}
          />
        </If>
        <VerticalComparison {...verticalComparisonContent} />
      </Box>
      <Choose>
        <When condition={!!wildfireFeatureFlag?.value}>
          <Box marginBottom={4}>
            <RewardsModule />
          </Box>
        </When>
        <Otherwise>
          <RegistrationModule {...registrationModuleContent} />
          <Testimonials {...testimonialsContent} />
        </Otherwise>
      </Choose>
      <Box marginY={{ mobile: '2', desktop: '3' }}>
        <NewsArticles />
      </Box>
      <CCBest {...ccBestContent} />
    </React.Fragment>
  );
};

FrontPage.displayName = 'FrontPage';
FrontPage.analyticsName = 'nw_home_page';
FrontPage.segmentPageName = 'homepage';

FrontPage.propTypes = {};

export default FrontPage;
